import { render, staticRenderFns } from "./database.vue?vue&type=template&id=40e8c9fc&scoped=true"
import script from "./database.vue?vue&type=script&lang=js"
export * from "./database.vue?vue&type=script&lang=js"
import style0 from "./database.vue?vue&type=style&index=0&id=40e8c9fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e8c9fc",
  null
  
)

export default component.exports